import {ActionReducer, INIT, UPDATE} from '@ngrx/store';

import {AppState} from '../core.state';
import {SessionStorageService} from '../storages/session-storage.service';
import {LocalStorageService} from '../storages/local-storage.service';

export const initStateFromLocalStorage = (
    reducer: ActionReducer<AppState>
): ActionReducer<AppState> => (state, action) => {
  const newState = reducer(state, action);
  if ([INIT.toString(), UPDATE.toString()].includes(action.type)) {
    return {...newState, ...LocalStorageService.loadInitialState(), ...SessionStorageService.loadSessionInitialState()};
  }
  return newState;
};
